import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DrilldownItem from '../DrillDownItem';
import RootCauseAnalysis from '../PoweredAI/RCA/RootCauseAnalysis';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '../../apollo/guidedInsights';
import { StoreDrilldownComponent } from '../StoreDrilldown/StoreDrilldownComponent';

const BreadcrumbLayout = () => {
	return (
		<div>
			<ApolloProvider client={apolloClient}>
				<Switch>
					<Route
						path="/details/item-details/:itemId/:itemName+"
						exact
						component={DrilldownItem}></Route>
					<Route
						path="/details/root-cause-analysis/:type/:id/:name/:identified/anomalyChange/:anomalyChange"
						exact
						component={RootCauseAnalysis}></Route>
					<Route
						path="/details/root-cause-analysis/:type/:id/:name/:identified/anomalyChange/:anomalyChange/item-details/:itemId/:itemName"
						exact
						component={DrilldownItem}></Route>
					<Route
						path="/details/store-drilldown/:type/:id/:name/:identified/anomalyChange/:anomalyChange/item-number/:itemId/threshold/:threshold"
						exact
						component={StoreDrilldownComponent}></Route>
				</Switch>
			</ApolloProvider>
		</div>
	);
};

export default BreadcrumbLayout;
